(ns frontend.view.components.simple-editor
  (:require
   [clojure.string :as string]
   [common.intelligence.common :as ic]
   [common.localization :as loc]
   [common.schema.field :as field]
   [frontend.state.current-session :as session]
   [frontend.view.entity-viewers.components :as nev-components]
   [frontend.view.entity-viewers.modules :as modules]
   [frontend.view.entity-viewers.entity-editor :as entity-editor]
   [frontend.view.entity-viewers.entities-editor :as entities-editor]
   [frontend.view.nev.events :as nev-events]
   [reagent.core :as r]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [common.schema.entity-type-names :as entity-type-names]))

(defn investor-ordering
  [investor]
  (let [investor-id (:db/id investor)]
    (concat (->> [:investor/type :investor/investor-type
                  :investor/interest-in-products :investor/preferred-currency
                  :investor/allocation-split]
                 (map (fn [a]
                        [investor-id a]))
                 (into []))
            (->> [:asset/street-address
                  :asset/street-address-2
                  :asset/country
                  :asset/city
                  :asset/zip-code
                  :company/website
                  :company/phone]
                 (map (fn [a]
                        (when-let [legal-entity (:investor/legal-entity investor)]
                          [legal-entity a])))
                 (remove nil?))
            (->> [:person/universal-email-address
                  :person/last-name
                  :person/first-name
                  :person/universal-phone-number
                  :person/location-address
                  :person/location-city
                  :person/location-country
                  :person/location-zip-code]
                 (map (fn [a]
                        (when-let [legal-entity (:investor/legal-entity investor)]
                          [legal-entity a])))
                 (remove nil?)))))

;; simple version of NEV: header and entity-editor module.
;; currently used with a modal.
(defn editor
  [entity modal-state close-modal!]
  (let [temp-atom (r/cursor modal-state [:temp])
        view-state-atom (r/cursor modal-state [:view-state])
        entity-type (:entity/type entity)
        entity-id (:db/id entity)
        entity-atom (r/cursor session/entities [entity-id])
        view-id (nev-components/default-view-id entity)
        module-id (nev-components/default-editor-module-id entity)
        enriched-entity (ic/enrich-entity entity)
        ;;simple enough to define here (first version):
        header-args {:email-attribute (when (= entity-type :entity.type/person)
                                        :person/universal-email-address)
                     :url-attribute   (when (= entity-type :entity.type/company)
                                        :company/website)
                     :logo-url        (case entity-type
                                        :entity.type/person
                                        (or (:person/avatar-url entity)
                                            (:person/avatar-url enriched-entity))
                                        :entity.type/company
                                        (or (:company/logo entity)
                                            (:company/logo enriched-entity))
                                        nil)}
        remove-fields (nev-components/remove-editor-fields entity)

        module-collapsed-path (fn [module-id]
                                [view-id :modules :module-config module-id :collapsed?])]
    (fn [entity modal-state close-modal!]
      (let [header-fields (nev-components/default-header-fields entity)]
        [:div
         [nev-components/header-module
          (merge
           {:component-state  temp-atom
            :view-state       view-state-atom
            :enriched-entity  enriched-entity
            :entity           @entity-atom
            :read-only-email? true
            :entity-atom      entity-atom
            :selected-fields  header-fields}
           header-args)]
         [modules/view
          {:view-id  view-id
           :ordering (get-in @session/view-config [view-id :modules :ordering])
           :save-modules-order! (partial nev-events/save-modules-order! (:entity/type entity))
           :modules
           [{:module-id  module-id
             :header     (loc/tr :nev-module/about-this-entity-type
                             [(string/lower-case (loc/tr (:entity/type entity)))])
             :collapsed? (get-in @session/view-config (module-collapsed-path module-id))
             :save-module-collapsed! (partial nev-events/save-module-collapsed! entity-type)
             :content    [:div
                          (if (= entity-type :entity.type/investor)
                            [entities-editor/view
                             {:state-atom       modal-state
                              :entity-ids       [entity-id (:investor/legal-entity entity)]
                              :view-id          view-id
                              :module-id        module-id
                              :remove-fields    remove-fields
                              :default-ordering (investor-ordering entity)
                              :ordering         (get-in
                                                 @session/view-config
                                                 [view-id :modules :module-config module-id
                                                  :ordering])
                              :close-modal!     close-modal!}]
                            [entity-editor/view
                             {:state-atom    modal-state
                              :entity-id     entity-id
                              :view-id       view-id
                              :module-id     module-id
                              :remove-fields remove-fields
                              :ordering      (get-in
                                              @session/view-config
                                              [view-id :modules :module-config module-id :ordering])
                              :close-modal!  close-modal!}])]}]}]]))))

(defn open-editor
  [entity]
  (modals/open-modal!
   dynamic-modal/modal-key
   {:title     (loc/tr :entity-type-info
                   [(->> entity
                         :entity/type
                         (get entity-type-names/entities)
                         :field/translations
                         :en)])
    :render-fn (fn [modal-state close-modal!]
                 [editor entity modal-state close-modal!])}))
